import { GET_ALL_STATES,GET_COUNTRY_STATES } from '../types'

const INITIAL_STATE = {
  allStates: [],
  countryStates: [],
}

const getStates = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_STATES:
      return {
        ...state,
        allStates: payload.data,
      }
      case GET_COUNTRY_STATES: 
      return {
        ...state,
        countryStates: payload.data,
      }
    default:
      return state
  }
}

export default getStates
